<template>
  <div class="item-content clear-fix">
    <div class="item-left">
      <div class="title">
        <slot name="leftTitle">星牌钢库</slot>
      </div>
      <div class="number">
        <slot name="leftNumber">5500.0</slot>
      </div>
    </div>
    <div class="item-right">
      <div class="title">
        <slot name="rightTitle">结账单数</slot>
      </div>
      <div class="number">
        <slot name="rightNumber">100</slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.item-content {
  padding-top: 10px;
  .item-left {
    float: left;
    width: 50%;
    text-align: center;
  }
  .item-right {
    float: left;
    width: 50%;
    text-align: center;
  }
  .title {
    margin: 0;
    font-size: 20px;
    line-height: 20px;
    text-align: center;
    height: 20px;
    font-family: Source Han Sans CN;
    font-weight: 300;
    color: rgba(66, 66, 66, 1);
  }
  .number {
    height: 38px;
    line-height: 38px;
    font-size: 26px;
    font-family: Source Han Sans CN;
    font-weight: 700;
    color: rgba(66, 66, 66, 1);
  }
}
</style>